const FooterTextNavigate = ({question, response, onClick}) =>{

    return(
        <p style={{display: "flex", gap: "15px", justifyContent: "center"}} className='textHasAccount'>{question} <span onClick={onClick} className='textHasAccountLogin'>{response}</span></p>
    )
}

export default FooterTextNavigate